var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.model),function(block){return [_c('div',{key:block.id,staticClass:"block",attrs:{"id":'block_' + block.id}},[_c('Editor',{attrs:{"model":block.content,"delete":"block.id"}})],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }